export const STAGE_ATTRIBUTE_NAME = 'strapi_stage';
export const ASSIGNEE_ATTRIBUTE_NAME = 'strapi_assignee';
